import React from "react";
import { useTheme } from "@mui/material/styles"; // added import for theme colors
import { LineChart } from "@mui/x-charts/LineChart";
import Box from "@mui/material/Box";

const LineChartDisplay = ({ data, currencyPrefix = "", xKey }) => {
  const theme = useTheme(); // get theme from MUI

  if (!data || !Array.isArray(data) || data.length === 0 || !data[0]) return null;
  const inferredXKey = xKey || (data[0].year !== undefined ? "year" : Object.keys(data[0])[0]);
  const seriesKeys = Object.keys(data[0]).filter(key => key !== inferredXKey);
  const series = seriesKeys.map((seriesKey, index) => ({
    label: seriesKey,
    data: data.map(item => item[seriesKey]),
    // using primary for first series and secondary for second series
    color: index === 0 ? theme.palette.primary.main : index === 1 ? theme.palette.secondary.main : undefined,
    valueFormatter: (value) => `${currencyPrefix}${Number(value).toLocaleString()}`,
    labelFormatter: (value) => `${seriesKey}: ${currencyPrefix}${Number(value).toLocaleString()}`,
  }));

  const xAxisValues = data.map(item => item["year"]);  // generate x-axis values dynamically

  return (
    <Box sx={{ width: "100%" }}>
      <LineChart
        xAxis={[{ 
          data: xAxisValues,
          valueFormatter: (value) => { 
            return value.toString(); // Convert to string for display
          },
        }]}  // set dynamic x-axis values
        yAxis={[{ valueFormatter: (value) => `${currencyPrefix || "€"}${Number(value).toLocaleString()}` }]}
        tooltip={{ valueFormatter: (value) => `${currencyPrefix || "€"}${Number(value).toLocaleString()}` }}
        legend={{ textStyle: { fontSize: 16, fontWeight: "bold" } }} // modified legend style for bold text
        series={series}
        height={300}
        margin={{left: 80, right: 40, top: 80, bottom: 20}}
      />
    </Box>
  );
};

export default LineChartDisplay;